import { Edit } from "@carbon/icons-react";
import {
    Button,
    StructuredListBody,
    StructuredListCell,
    StructuredListRow,
    StructuredListWrapper
} from "@carbon/react";

const profileRows = [
    ["Nombre:", "firstName"],
    ["Apellidos:", "lastName"],
    ["Email:", "email"]
];

const getProfileValue = ({ firstName, lastName, email }, key) => ({
    firstName,
    lastName,
    email
}[key] || "-");

const ProfileInfo = ({ firstName, lastName, email, onEditProfile }) => {
    const profileValues = { firstName, lastName, email };

    return (
        <div className="user-info-container">
            <StructuredListWrapper className="profile-details" aria-label="Datos del perfil">
                <StructuredListBody>
                    {profileRows.map(([label, key]) => (
                        <StructuredListRow key={key}>
                            <StructuredListCell head>{label}</StructuredListCell>
                            <StructuredListCell>{getProfileValue(profileValues, key)}</StructuredListCell>
                        </StructuredListRow>
                    ))}
                </StructuredListBody>
            </StructuredListWrapper>
            <div className="profile-actions-container">
                <Button className="edit-profile" renderIcon={Edit} onClick={onEditProfile}>
                    Editar Perfil
                </Button>
            </div>
        </div>
    );
};

export default ProfileInfo;
